export function getPersonalInfo(personalInfoRepository) {
  return personalInfoRepository.get();
}